var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-picker-container"},[_c('div',{staticClass:"color-picker"},[_c('input',{attrs:{"type":"color"},domProps:{"value":_vm.color || '#ffffff'},on:{"input":(e) => _vm.$emit('color-picked', e.target.value)}})]),_c('p',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }